// extracted by mini-css-extract-plugin
export default {"title":"Heading_title__T+c2x","feature":"Heading_feature__67D9Q","feature__icon":"Heading_feature__icon__KFAtZ"};